module.exports = __webpack_public_path__ + "img/5000.ec53285c.jpg";